import { socialLogin, socialSignup } from "@/social/index.js";

const Kakao = {
  kakao_key: process.env.VUE_APP_KAKAO_KEY,

  loadScript() {
    return new Promise((resolve, reject) => {
      if (window.Kakao && window.Kakao.Auth) {
        // 이미 로드된 경우
        if (!window.Kakao.isInitialized()) {
          window.Kakao.init(this.kakao_key);
        }
        return resolve(true);
      }

      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://developers.kakao.com/sdk/js/kakao.js";

      script.onload = () => {
        if (!window.Kakao.isInitialized()) {
          window.Kakao.init(this.kakao_key);
        }
        resolve(true);
      };

      script.onerror = reject;

      document.head.appendChild(script);
    });
  },

  makeReq(kakaoRes, accessToken) {
    return {
      id: kakaoRes.id,
      email: kakaoRes.kakao_account?.email || "",
      name: kakaoRes.kakao_account?.profile?.nickname || "",
      social: "kakao",
      access_token: accessToken,
    };
  },

  login(callback) {
    this.loadScript().then(() => {
      window.Kakao.Auth.login({
        success: (authObj) => {
          window.Kakao.API.request({
            url: "/v2/user/me",
            success: async (res) => {
              const req = this.makeReq(res, authObj.access_token);
              console.log("👤 사용자 정보:", req);

              const [flag, data] = await socialLogin(req); // ✅ await 처리
              if (typeof callback === "function") {
                callback(req, flag, data); // ✅ 결과 같이 전달
              }
            },
            fail: (err) => {
              console.error("❌ 사용자 정보 요청 실패", err);
            },
          });
        },
        fail: (err) => {
          console.error("❌ 로그인 실패", err);
        },
      });
    });
  },

  async signup(form, callback) {
    const [flag, data] = await socialSignup(form); // await 처리
    if (typeof callback === "function") {
      callback(flag, data); // ✅ 결과 같이 전달
    }
  },
};

export default Kakao;
